import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: a wall-mounted framed painting authored at its
// true mounting height (canvas centred around y = 1.5), flat against the wall
// at z = 0, facing +Z. Abstract colour blocks sit proud of the canvas.
const FRAME = "#c8975a";
const CANVAS = "#e8e4dc";
const BLOCK_A = "#8a9aa8";
const BLOCK_B = "#a05a40";
const BLOCK_C = "#5f8f4e";

export const wallPainting = defineModel({
  id: "wall-painting",
  batchId: "modern",
  name: "Wall painting",
  tags: ["modern", "interior", "decor", "art", "painting", "wall-mounted"],
  summary: "A wall-mounted abstract painting in an oak frame.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // oak frame against the wall
      { geometry: new THREE.BoxGeometry(0.84, 0.64, 0.04), color: FRAME, position: [0, 1.5, 0.02] },
      // canvas panel proud of the frame
      { geometry: new THREE.BoxGeometry(0.74, 0.54, 0.02), color: CANVAS, position: [0, 1.5, 0.045] },
      // abstract colour blocks proud of the canvas
      { geometry: new THREE.BoxGeometry(0.3, 0.34, 0.012), color: BLOCK_A, position: [-0.16, 1.52, 0.06] },
      { geometry: new THREE.BoxGeometry(0.2, 0.2, 0.012), color: BLOCK_B, position: [0.17, 1.42, 0.06] },
      { geometry: new THREE.BoxGeometry(0.16, 0.12, 0.012), color: BLOCK_C, position: [0.14, 1.62, 0.06] },
    ];
  },
  animations: [],
});
